<template>
  <main class="wrap-component" :class="`wrap-component--${tableType}`">
    <slot />
  </main>
</template>

<script>
export default {
  props: ["tableType"],
};
</script>

<style lang='scss'>
.wrap-component {
  padding: 10px 20px;

  .desktop {
    display: flex;
  }
  .mobile {
    display: none;
  }

  header {
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: space-between;

    h1 {
      font-size: 16px;
    }
  }

  .table-wrapper {
    header {
      height: 35px;

      .tabs {
        > section {
          display: flex;
        }
      }
    }
  }

  &:not(.wrap-component--white) {
    .table {
      thead {
        tr,
        th {
          background: transparent;
        }
      }

      tbody {
        tr {
          background: #f0f0f7;

          &.inactive-row {
            background-color: #fff8f8;
            &:hover {
              background-color: #fbf0f0;
            }
          }

          &:hover {
            background: #f0f0f7;
          }
        }
      }
    }
  }
  // }
}

@media screen and (max-width: 1000px) {
  .wrap-component {
    padding: 10px 15px;
    margin-bottom: var(--header--mobile-tabs-height);

    .desktop {
      display: none;
    }
    .mobile {
      display: flex;
    }

    header {
      justify-content: center;
      flex-direction: column;
      height: fit-content;
      gap: 10px;
    }
  }
}
</style>
